<script>
import { readAllMenusDates } from '@/services/MenuMakerServices';
export default {
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),

      allMenuDates: null,
    };
  },
  computed: {
    menuDates() {
      return Object.keys(this.allMenuDates).sort((a, b) => b.localeCompare(a));
    },

  },
  async created() {
    console.clear();
    const menuDates = await readAllMenusDates(this.uId, this.token);
    if (menuDates) {
      this.allMenuDates = menuDates;
      console.log('*** got menuDates ***', this.menuDates);
    }
  },
}
</script>

<template>
<div id="page-menus-all" class="pa-4">
  <h1 class="my-4 text-center">Menu Maker 2000</h1>

  <div class="d-flex justify-center pt-8 pb-16 mx-auto">
    <router-link to="/menu">
      <v-btn color="green-lighten-1">Start a New Menu</v-btn>
    </router-link>
  </div>


  <div class="d-flex flex-column align-center">
    <h2>Past Menus</h2>
    <p class="text-body-2 mb-7"><i>newest to oldest</i></p>
    <ol v-if="allMenuDates">
      <li v-for="d of menuDates" :key="d" class="mb-6">
        <router-link :to="`/menu/${d}`" class="ps-3 text-blue-darken-3 text-decoration-none">{{ d }}</router-link>
      </li>
    </ol>
  </div>



</div>
</template>

<style scoped lang="scss">

</style>
